import { useState, FormEvent, ChangeEvent } from 'react';
import emailjs from '@emailjs/browser';
import { ValuePitch } from './components/ValuePitch';
import { PricingGrid } from './components/PricingGrid';
import ContactForm from './components/ContactForm';
import { TechStack } from './components/TechStack';
import { Footer } from './components/Footer';

interface FormData {
	name: string;
	email: string;
	timeline: string;
	message: string;
	package: string;
}

// Initialize EmailJS with your public key
emailjs.init({
	publicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY,
});

function App() {
	const [formData, setFormData] = useState<FormData>({
		name: '',
		email: '',
		timeline: '1 day',
		message: '',
		package: ''
	});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);

	const handleSubmit = async (e: FormEvent) => {
		e.preventDefault();
		setIsSubmitting(true);

		try {
			await emailjs.send(
				import.meta.env.VITE_EMAILJS_SERVICE_ID,
				import.meta.env.VITE_EMAILJS_TEMPLATE_ID,
				{
					from_name: formData.name,
					from_email: formData.email,
					timeline: formData.timeline,
					message: formData.message,
					package: formData.package || 'No package selected',
					to_name: 'OneDayMVP Team'
				}
			);

			setIsSuccess(true);
			setFormData({
				name: '',
				email: '',
				timeline: '1 day',
				message: '',
				package: ''
			});
		} catch (error) {
			console.error('Error sending email:', error);
			alert('Sorry, there was an error sending your message. Please try again later.');
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target;
		setFormData(prev => ({
			...prev,
			[name]: value
		}));
	};

	const handleSelectPackage = (packageName: string, timeline: string) => {
		setFormData(prev => ({
			...prev,
			package: packageName,
			timeline: timeline
		}));
	};

	return (
		<div className="min-h-screen py-12 px-4 sm:px-6 lg:px-8">
			<ValuePitch />
			
			{/* Hero Section */}
			<div className="text-center mb-16">
				<h1 className="text-5xl font-bold mb-4">
					Transform Your Idea into MVP
				</h1>
				<p className="text-xl text-gray-300">
					this site was generated and deployed in 4 minutes
				</p>
			</div>

			<div>
				<h2 className="text-3xl font-bold text-center mb-12">Choose Your Package</h2>
				<PricingGrid onSelectPackage={handleSelectPackage} />
			</div>

			<div>
				<h2 className="text-3xl font-bold text-center mb-12">Our Tech Stack</h2>
				<TechStack />
			</div>

			<div>
				<h2 className="text-3xl font-bold text-center mb-12">Get in Touch</h2>
				<ContactForm
					formData={formData}
					onSubmit={handleSubmit}
					onChange={handleChange}
					isSubmitting={isSubmitting}
					isSuccess={isSuccess}
				/>
			</div>
			<Footer />
		</div>
	);
}

export default App;
